var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeoOverTimeRaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 208.11,
    viewBox: "0 0 330.734 208.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3110",
    "data-name": "Group 3110",
    transform: "translate(-1897.428 -1701.493)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Original_Diagnosis_Rank:",
    "data-name": "Original Diagnosis Rank:",
    transform: "translate(2022 1719.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Original Diagnosis Rank:")), /*#__PURE__*/React.createElement("text", {
    id: "Last_6_months",
    "data-name": "Last 6 months",
    transform: "translate(1912.838 1719.35)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Last 6 months")), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(2158 1701.655)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 70,
    height: 29.003,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#babcbf",
    strokeMiterlimit: 10,
    strokeWidth: 0.325
  }), /*#__PURE__*/React.createElement("text", {
    id: "_20",
    "data-name": 20,
    transform: "translate(32.459 18.495)",
    fill: "#74ad85",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.861,
    y: 0
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    id: "_20-2",
    "data-name": 20,
    transform: "translate(1932 1832)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.23,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("text", {
    id: "_10",
    "data-name": 10,
    transform: "translate(1932 1794)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.23,
    y: 0
  }, "10")), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(1929 1756)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.615,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "_30",
    "data-name": 30,
    transform: "translate(1932 1870)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.23,
    y: 0
  }, "30")), /*#__PURE__*/React.createElement("text", {
    id: "May",
    transform: "translate(2163 1888.979)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.451,
    y: 0
  }, "May")), /*#__PURE__*/React.createElement("text", {
    id: "Mar",
    transform: "translate(2053 1887.884)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.777,
    y: 0
  }, "Mar")), /*#__PURE__*/React.createElement("text", {
    id: "Jan",
    transform: "translate(1945 1888.979)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.237,
    y: 0
  }, "Jan")), /*#__PURE__*/React.createElement("text", {
    id: "Month",
    transform: "translate(2075.546 1906.603)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.363,
    y: 0
  }, "Month")), /*#__PURE__*/React.createElement("text", {
    id: "Overall_Rank",
    "data-name": "Overall Rank",
    transform: "translate(1907.428 1813.564) rotate(-90)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -27.578,
    y: 0
  }, "Overall Rank")), /*#__PURE__*/React.createElement("text", {
    id: "Jun",
    transform: "translate(2217 1888.979)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.274,
    y: 0
  }, "Jun")), /*#__PURE__*/React.createElement("text", {
    id: "Apr",
    transform: "translate(2107 1888.979)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.759,
    y: 0
  }, "Apr")), /*#__PURE__*/React.createElement("text", {
    id: "Feb",
    transform: "translate(1999 1888.979)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.218,
    y: 0
  }, "Feb")), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    y1: 123.047,
    transform: "translate(1945.787 1754.5)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    y1: 123.531,
    transform: "translate(2055.847 1754.016)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    y1: 123.531,
    transform: "translate(2165.908 1754.016)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    y1: 123.531,
    transform: "translate(2000.817 1754.016)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    y1: 123.531,
    transform: "translate(2110.877 1754.016)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    y1: 123.531,
    transform: "translate(2220.938 1754.016)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x2: 284.846,
    transform: "translate(1936.155 1830.5)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    x2: 284.846,
    transform: "translate(1936.155 1792.5)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x2: 284.846,
    transform: "translate(1936.155 1754.5)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    x2: 284.846,
    transform: "translate(1936.155 1868.5)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M216.786,205.2l54.753-5.067,54.884-7.008,55.616,7.008,54.995-7.008h54.9",
    transform: "translate(1729.101 1575.744)",
    fill: "none",
    stroke: "#e27867",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_332",
    "data-name": "Ellipse 332",
    cx: 4.281,
    cy: 4.281,
    r: 4.281,
    transform: "translate(1898.428 1710.938)",
    fill: "#e27867"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_334",
    "data-name": "Ellipse 334",
    cx: 4.688,
    cy: 4.688,
    rx: 4.688,
    ry: 4.688,
    transform: "translate(1941.063 1775.763)",
    fill: "#e27867"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_335",
    "data-name": "Ellipse 335",
    cx: 4.688,
    cy: 4.688,
    rx: 4.688,
    ry: 4.688,
    transform: "translate(1995.813 1771.383)",
    fill: "#e27867"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_336",
    "data-name": "Ellipse 336",
    cx: 4.688,
    cy: 4.688,
    rx: 4.688,
    ry: 4.688,
    transform: "translate(2050.562 1764.383)",
    fill: "#e27867"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_337",
    "data-name": "Ellipse 337",
    cx: 4.688,
    cy: 4.688,
    rx: 4.688,
    ry: 4.688,
    transform: "translate(2106.406 1771.243)",
    fill: "#e27867"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_338",
    "data-name": "Ellipse 338",
    cx: 4.688,
    cy: 4.688,
    rx: 4.688,
    ry: 4.688,
    transform: "translate(2161.154 1764.388)",
    fill: "#e27867"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_339",
    "data-name": "Ellipse 339",
    cx: 4.688,
    cy: 4.688,
    rx: 4.688,
    ry: 4.688,
    transform: "translate(2215.904 1764.483)",
    fill: "#e27867"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_333",
    "data-name": "Ellipse 333",
    cx: 4.281,
    cy: 4.281,
    r: 4.281,
    transform: "translate(2008.824 1710.938)",
    fill: "#74ad85"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_340",
    "data-name": "Ellipse 340",
    cx: 4.688,
    cy: 4.688,
    rx: 4.688,
    ry: 4.688,
    transform: "translate(1941.063 1825.947)",
    fill: "#74ad85"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoOverTimeRaw);
export default __webpack_public_path__ + "static/media/seoOverTimeRaw.fcd22a85.svg";
export { ForwardRef as ReactComponent };